'use strict';

var React = require('react'),
    FontTest = require('../atoms/FontTest'),
    enforcePElements = require('../utils/enforcePElements');

require('./legacy/Stamp.less');
require('./Text.less');

var Text = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired,
  },

  shouldComponentUpdate: function () {
    return false;
  },

  render: function () {
    var html = enforcePElements(this.props.text);

    return (
      <div className='stamp-Text'
           data-scroll-anchor='text'>
        <FontTest family='minion-pro-condensed'
                  test={html}>
          <div className='stamp-Text-box'
               dangerouslySetInnerHTML={{ __html: html }} />
        </FontTest>
      </div>
    );
  }
});

module.exports = Text;


/** WEBPACK FOOTER **
 ** ./stamp/Text.jsx
 **/